<template>
    <div class="main-container">
        <div
            class="card-container"
            :class="store.selectedUserType == SubscriptionType.INDIVIDUAL ? 'border-2 border-blue-700' : 'border border-zinc-300'"
            @click="selectUserType(SubscriptionType.INDIVIDUAL)"
        >
            <Individual class="h-6 w-6" />
            <label for="individual" class="title-text">Individual</label>
        </div>

        <div
            class="card-container"
            :class="store.selectedUserType == SubscriptionType.COUPLES ? 'border-2 border-blue-700' : 'border border-zinc-300'"
            @click="selectUserType(SubscriptionType.COUPLES)"
        >
            <Couples class="h-6 w-6" />
            <label for="couples" class="title-text">Couples</label>
        </div>

        <div
            class="card-container"
            :class="store.selectedUserType == SubscriptionType.FAMILY ? 'border-2 border-blue-700' : 'border border-zinc-300'"
            @click="selectUserType(SubscriptionType.FAMILY)"
        >
            <Family class="h-6 w-6" />
            <label for="family" class="title-text">Family</label>
        </div>
    </div>
</template>

<script setup lang="ts">
import Couples from '~/assets/images/icons/couples.svg';
import Family from '~/assets/images/icons/family.svg';
import Individual from '~/assets/images/icons/individual.svg';
import { useSubscribeStore } from '~/stores/components/modals/subscription-modal';
import { SubscriptionType } from '~/types/licenses/licenses';

const store = useSubscribeStore();

const selectUserType = (type: SubscriptionType) => {
    store.selectedUserType = type;

    if(type === SubscriptionType.INDIVIDUAL) {
        store.licenseCount = 1;
    } else if (type === SubscriptionType.COUPLES) {
        store.licenseCount = 2;
    } else if (type === SubscriptionType.FAMILY) {
        store.licenseCount = 4;
    }
};
</script>

<style lang="scss" scoped>
.main-container {
    @apply flex flex-row items-center sm:gap-6 gap-2 self-stretch;

    .card-container {
        @apply flex flex-col justify-center items-center gap-2 sm:p-6 px-2 py-3 flex-1;
        @apply rounded-lg bg-white shadow-sm cursor-pointer w-full;
    }

    .title-text {
        @apply text-zinc-950 font-inter text-sm font-semibold leading-4;
    }
}
</style>
